import type { SVGProps } from 'react';

/** Small stroke icons (14 px, currentColor) used inline next to text. */
export function CloudIcon({ className, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden className={className} {...rest}>
      <path d="M4.5 12.5h7a2.75 2.75 0 0 0 .4-5.47A3.75 3.75 0 0 0 4.7 6.2 3.15 3.15 0 0 0 4.5 12.5z" />
    </svg>
  );
}
/** The Deepgram mark used next to its latency: a rounded square with a D. */
export function DeepgramMark({ className }: { className?: string }) {
  return (
    <span aria-hidden className={`inline-grid h-[14px] w-[14px] place-items-center rounded-[3px] bg-fg font-mono text-[9px] font-bold leading-none text-bg ${className ?? ''}`}>
      D
    </span>
  );
}
export function PencilIcon({ className, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden className={className} {...rest}>
      <path d="M11.3 2.3a1.5 1.5 0 0 1 2.4 2.4L5.5 12.9 2 14l1.1-3.5z" />
      <path d="M10 3.6l2.4 2.4" />
    </svg>
  );
}
